import { ACCESS_TOKEN, ACCESS_TOKEN_KEYCLOAK, REFRESH_TOKEN } from '../config/data';

export const setStorageByName = (key: string, value: any) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(key, JSON.stringify(value));
  }
};

export const getStorageByName = (key: string) => {
  if (typeof window !== 'undefined') {
    const item: any = window.localStorage.getItem(key);
    try {
      return JSON.parse(item);
    } catch (e) {
      return item;
    }
  }
};

export const removeStorageByName = (key: string) => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(key);
  }
};

export const clearAllStorage = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.clear();
  }
};

export const getAuthenticator = () => {
  return getStorageByName(ACCESS_TOKEN) || getStorageByName(ACCESS_TOKEN_KEYCLOAK);
};

export const getRefreshToken = () => {
  return getStorageByName(REFRESH_TOKEN);
};

export const setRefreshToken = (value: any) => {
  setStorageByName(REFRESH_TOKEN, value);
};


export const setAuthenticatorKeyCloak = (value: any) => {
  setStorageByName(ACCESS_TOKEN_KEYCLOAK, value);
};
export const setAuthenticator = (value: any) => {
  setStorageByName(ACCESS_TOKEN, value);
};
export const clearAccessToken = () => {
  removeStorageByName(ACCESS_TOKEN);
};
